import React from "react";
import { Box, Typography } from "@mui/material";
import { DetailItem } from "./ModalDetailsGeneric";

/** Label/value pair as it arrives from the modal data builders. */
export interface TitleValue {
  title?: string;
  value?: string;
}

/** Placeholder rendered when a value is missing. */
export const EMPTY_VALUE = "-";

/** Human labels for the per-state sections (approved / orded). */
export const STATE_LABELS: Record<string, string> = {
  approved: "Aprovado",
  orded: "Solicitado",
};

/** Returns the value, or "-" when it is null/undefined or an empty string. */
export function dash(value?: string): string {
  return value != null && value.trim() !== "" ? value : EMPTY_VALUE;
}

/**
 * Returns the per-state keys present in the modal data, ordered for display
 * (orded before approved). Only "approved" and "orded" are recognized.
 */
export function getStateKeys(data: Record<string, unknown>): string[] {
  return Object.keys(data)
    .filter((key) => key === "approved" || key === "orded")
    .reverse();
}

/**
 * Builds the request-number header item, optionally rendering a status node
 * next to the value.
 */
export function buildRequestNumberItem(
  label: string,
  value?: string,
  statusNode?: React.ReactNode
): DetailItem {
  return {
    label,
    value:
      statusNode != null ? (
        <Box display="flex" alignItems="center" gap={1}>
          {dash(value)}
          {statusNode}
        </Box>
      ) : (
        dash(value)
      ),
  };
}

/** Builds the full-width heading item that introduces a per-state section. */
export function buildStateLabelItem(key: string): DetailItem {
  return {
    label: "",
    fullWidth: true,
    value: (
      <Typography fontWeight={700} color="shadesOfDark.dark">
        {STATE_LABELS[key] ?? key}
      </Typography>
    ),
  };
}
